export default {
	getTotalSpentFromTransactions(transactions, category) {
		let total = 0;
		transactions.forEach((transaction) => {
			total += transaction.getAmountTowardCategory(category);
		});
		return total;
	},
};